import { render, staticRenderFns } from "./start-examination-component.vue?vue&type=template&id=74f4dd47"
import script from "./start-examination-component.vue?vue&type=script&setup=true&lang=ts"
export * from "./start-examination-component.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./start-examination-component.vue?vue&type=style&index=0&id=74f4dd47&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports